document.addEventListener("DOMContentLoaded", function () {
    const wrapper = document.getElementById("mobile-menu-recap");
    const menu = wrapper.querySelector(".menu_mobile_inner_wrapper > ul");
    const openBtn = document.getElementById("mobile-menu-button");
    const closeBtn = document.getElementById("mobile-menu-button-close");
    const menuStack = [];

    if (!menu) return;

    // Ensure header exists
    function createOrGetHeader(panel, isSubmenu = false) {
        let header = panel.querySelector(".mobile-menu-recap_header");
        if (!header) {
            header = document.createElement("div");
            header.classList.add("mobile-menu-recap_header");
            panel.prepend(header);
        }

        // Remove any existing back buttons
        header.querySelectorAll(".back-btn").forEach(btn => btn.remove());

        // Back button only for submenus
        if (isSubmenu) {
            const backBtn = document.createElement("button");
            backBtn.classList.add("back-btn");
            // backBtn.textContent = "‹";
            backBtn.addEventListener("click", () => closePanel(panel));
            header.appendChild(backBtn);
        }

        // Close button always
        if (!header.querySelector(".close-btn")) {
            const closeBtn = document.createElement("button");
            closeBtn.classList.add("close-btn");
            // closeBtn.textContent = "×";
            closeBtn.addEventListener("click", closeMenu);
            header.appendChild(closeBtn);
        }

        return header;
    }

    function closeMenu() {
        wrapper.classList.remove("open");
        wrapper.style.transition = "";
        wrapper.style.background = "transparent";
        menu.style.display = "block";
        menuStack.length = 0;
        document.querySelectorAll(".mobile-submenu-panel").forEach(p => p.remove());
    }

    function createSubmenuPanel(parentItem) {
        const parentLink = parentItem.querySelector("a");
        const childrenUl = parentItem.querySelector(":scope > ul");

        if (!childrenUl || !parentLink) return window.location.href = parentLink.href;

        menuStack.push(parentItem);
        menu.style.display = "none";

        const panel = document.createElement("div");
        panel.classList.add("mobile-submenu-panel");

        // Start offscreen right
        panel.style.left = "-100%";

        panel.innerHTML = `
            <a class="mm-navbar_recap-title" href="${parentLink.href}">
                ${parentLink.textContent.trim()}
            </a>
            <ul class="submenu-list">${childrenUl.innerHTML}</ul>
        `;

        wrapper.querySelector(".d-flex").appendChild(panel);

        // Apply header
        createOrGetHeader(panel, true);

        // Deeper submenu links
        panel.querySelectorAll("li > a").forEach(childLink => {
            const liChild = childLink.closest("li");
            const nextUl = liChild.querySelector(":scope > ul");
            if (nextUl) {
                childLink.addEventListener("click", e => {
                    e.preventDefault();
                    createSubmenuPanel(liChild);
                });
            }
        });

        // Animate slide in
        requestAnimationFrame(() => {
            panel.style.transition = "left 0.3s ease-in-out";
            panel.style.left = "0"; // slide left
        });
    }

    function closePanel(panel) {
        // Animate slide out right
        panel.style.transition = "left 0.3s ease-in-out";
        panel.style.left = "-100%";
        setTimeout(() => panel.remove(), 300);

        menuStack.pop();
        if (menuStack.length === 0) menu.style.display = "block";
    }

    // Open / close main menu
    openBtn?.addEventListener("click", () => {
        wrapper.classList.add("open");
        createOrGetHeader(wrapper.querySelector(".d-flex"), false);
        wrapper.style.transition = "background 0.4s ease-in-out";
        wrapper.style.background = "var(--overlay)";
    });

    closeBtn?.addEventListener("click", closeMenu);

    // Top-level parent links with children
    menu.querySelectorAll(":scope > li > a").forEach(link => {
        const li = link.closest("li");
        const childrenUl = li.querySelector(":scope > ul");
        if (childrenUl) {
            link.addEventListener("click", e => {
                e.preventDefault();
                createSubmenuPanel(li);
            });
        }
    });
});
